
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

interface QuizActionsProps {
  loading: boolean;
  onSkip?: () => void;
}

const QuizActions = ({ loading, onSkip }: QuizActionsProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col sm:flex-row justify-between mt-8 gap-4">
      <Button
        onClick={() => navigate(-1)}
        variant="outline"
        className="text-gray-600"
        disabled={loading}
      >
        <ArrowLeft className="mr-2 w-4 h-4" />
        Go Back
      </Button>
      
      {onSkip && (
        <button
          onClick={onSkip}
          className="text-gray-500 hover:text-gray-700 text-sm underline transition-colors"
          disabled={loading}
        >
          Skip Quiz
        </button>
      )}
    </div>
  );
};

export default QuizActions;
